import { Annotation } from './annotation';
import { Component } from './component';
import { Cube } from './cube';
import { Cylinder } from './cylinder';
import { Group } from './group';
import { Led } from './led';
import { Measurement } from './measurement';
import { Model } from './model';
import { Projector } from './newProjector';
import { Plane } from './plane';
import { Sphere } from './sphere';
import { TorusKnot } from './torusKnot';

export const OBJECT_TYPES = {
  group: Group,
  plane: Plane,
  cube: Cube,
  box: Cube,
  sphere: Sphere,
  cylinder: Cylinder,
  torusknot: TorusKnot,
  component: Component,
  projector: Projector,
  led_screen: Led,
  model: Model,
  annotation: Annotation,
  measurement: Measurement,
};
